import { render } from "./header.vue?vue&type=template&id=4361f1cd&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=4361f1cd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4361f1cd"

export default script